import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, API, authedFetch } from "../lib/api";
import { ArrowLeft, BookOpen, Upload, Trash2, Download, Pencil, Check, X } from "lucide-react";

const KINDS = [
  { value: "scaffold", label: "Scaffalature" },
  { value: "dpi", label: "DPI" },
];

export default function Manuals() {
  const [kind, setKind] = useState("scaffold");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploadOpen, setUploadOpen] = useState(false);
  const [renameId, setRenameId] = useState(null);
  const [renameVal, setRenameVal] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/manuals?kind=${kind}`);
      setItems(data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [kind]);

  const remove = async (id) => {
    if (!window.confirm("Eliminare definitivamente questo manuale? Verrà rimosso da tutti i DPI/scaffalature che lo utilizzano.")) return;
    await api.delete(`/manuals/${id}`);
    load();
  };

  const downloadManual = async (m) => {
    try {
      const res = await authedFetch(`${API}/files/${m.path}`);
      if (!res.ok) { alert(`Errore download (${res.status})`); return; }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = m.filename || `${m.title}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch (e) { alert(`Errore: ${e.message}`); }
  };

  const submitRename = async (id) => {
    const v = renameVal.trim();
    if (!v) { setRenameId(null); return; }
    await api.patch(`/manuals/${id}`, { title: v });
    setRenameId(null);
    load();
  };

  return (
    <div className="container max-w-5xl mx-auto p-4 sm:p-6">
      <Link to="/" className="bru-link inline-flex items-center gap-1 text-sm mb-3" data-testid="manuals-back">
        <ArrowLeft className="w-4 h-4" />
        Dashboard
      </Link>
      <div className="flex items-center justify-between mb-5 flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <BookOpen className="w-8 h-8 text-[#ff5a00]" />
          <div>
            <h1 className="text-3xl font-bold tracking-tight">Manuali</h1>
            <div className="text-sm text-neutral-500">Deposito riutilizzabile per DPI e Scaffalature</div>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setUploadOpen(true)}
          className="bru-btn bru-btn-primary"
          data-testid="manual-upload-open"
        >
          <Upload className="w-4 h-4" />
          Carica manuale
        </button>
      </div>

      <div className="inline-flex bg-neutral-100 rounded-full p-1 mb-4" role="tablist">
        {KINDS.map((k) => (
          <button
            key={k.value}
            type="button"
            onClick={() => setKind(k.value)}
            className={`px-4 py-1.5 rounded-full text-sm font-bold transition ${kind === k.value ? "bg-black text-white" : "text-neutral-600 hover:bg-white"}`}
            data-testid={`manuals-tab-${k.value}`}
          >
            {k.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-center text-neutral-500 py-12">Caricamento…</div>
      ) : items.length === 0 ? (
        <div className="bru-card p-8 text-center text-neutral-500" data-testid="manuals-empty">
          Nessun manuale caricato.
          <div className="text-xs mt-2">Carica il primo per renderlo selezionabile nei form.</div>
        </div>
      ) : (
        <div className="space-y-2">
          {items.map((m) => (
            <div key={m.id} className="bru-card p-4 flex items-center gap-3" data-testid={`manual-row-${m.id}`}>
              <div className="w-12 h-12 rounded-xl bg-orange-50 border border-orange-200 flex items-center justify-center shrink-0">
                <BookOpen className="w-6 h-6 text-[#ff5a00]" />
              </div>
              <div className="flex-1 min-w-0">
                {renameId === m.id ? (
                  <div className="flex items-center gap-2">
                    <input
                      autoFocus
                      className="bru-input !py-1.5 !px-2 !text-sm flex-1"
                      value={renameVal}
                      onChange={(e) => setRenameVal(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") submitRename(m.id);
                        else if (e.key === "Escape") setRenameId(null);
                      }}
                    />
                    <button type="button" onClick={() => submitRename(m.id)} className="text-green-600"><Check className="w-5 h-5" /></button>
                    <button type="button" onClick={() => setRenameId(null)} className="text-neutral-500"><X className="w-5 h-5" /></button>
                  </div>
                ) : (
                  <>
                    <div className="font-bold text-sm truncate">{m.title}</div>
                    <div className="text-xs text-neutral-500 truncate">{m.filename} · {(m.size / 1024).toFixed(0)} KB</div>
                  </>
                )}
              </div>
              <button type="button" onClick={() => { setRenameId(m.id); setRenameVal(m.title); }}
                className="text-neutral-500 hover:text-black" title="Rinomina"
                data-testid={`manual-rename-${m.id}`}>
                <Pencil className="w-4 h-4" />
              </button>
              <button type="button" onClick={() => downloadManual(m)}
                className="text-neutral-500 hover:text-black" title="Scarica"
                data-testid={`manual-download-${m.id}`}>
                <Download className="w-5 h-5" />
              </button>
              <button type="button" onClick={() => remove(m.id)}
                className="text-neutral-500 hover:text-[#ff3b30]" title="Elimina"
                data-testid={`manual-delete-${m.id}`}>
                <Trash2 className="w-5 h-5" />
              </button>
            </div>
          ))}
        </div>
      )}

      {uploadOpen && (
        <UploadManualDialog
          kindDefault={kind}
          onClose={() => setUploadOpen(false)}
          onDone={() => { setUploadOpen(false); load(); }}
        />
      )}
    </div>
  );
}

function UploadManualDialog({ kindDefault, onClose, onDone }) {
  const [kind, setKind] = useState(kindDefault);
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!file) { setErr("Seleziona un file"); return; }
    if (!title.trim()) { setErr("Titolo obbligatorio"); return; }
    setLoading(true); setErr("");
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("kind", kind);
      fd.append("title", title.trim());
      await api.post("/manuals", fd);
      onDone();
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Errore caricamento");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bru-card w-full max-w-md p-6" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-xl font-bold mb-4">Carica manuale</h2>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="bru-label">Categoria</label>
            <select className="bru-input" value={kind} onChange={(e) => setKind(e.target.value)}>
              {KINDS.map((k) => <option key={k.value} value={k.value}>{k.label}</option>)}
            </select>
          </div>
          <div>
            <label className="bru-label">Titolo</label>
            <input
              className="bru-input"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Es. Manuale d'uso DPI casco"
              data-testid="manual-title-input"
            />
          </div>
          <div>
            <label className="bru-label">File PDF / Immagine (max 30 MB)</label>
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,.webp,.heic"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
              className="bru-input"
              data-testid="manual-file-input"
            />
          </div>
          {err && <div className="text-sm text-[#ff3b30]">{err}</div>}
          <div className="flex justify-end gap-3 pt-2">
            <button type="button" onClick={onClose} className="bru-btn bru-btn-secondary">Annulla</button>
            <button type="submit" disabled={loading} className="bru-btn bru-btn-primary disabled:opacity-60" data-testid="manual-upload-submit">
              {loading ? "CARICAMENTO…" : "CARICA"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
